// extracted by mini-css-extract-plugin
module.exports = {"amount":"accounting_amount__2u-_e","amount__header":"accounting_amount__header__1zfgi","amount__row":"accounting_amount__row__2eotP"};